export default "__VITE_ASSET__Dy6WIjUc__"